import {Selectors} from '../Settings';
import {$window, $body} from '../../../../../ig_template/Resources/Public/JavaScript/Constants';
import Banner from '../../../../../ig_template/Resources/Public/JavaScript/Elements/Banner';
import Rotation from './Rotation';

/**
 * Rotator
 */
export default class Rotator {
    constructor($rotator) {
        this.$rotator = $rotator;
        this.rotations = this.getRotations();

        if($window.width() >= 850) {
            this.height = this.getBiggestValue(this.getRotationRowHeights());
        }else {
            this.height = this.getBiggestValue(this.getRotationHeights());
            this.setRotationExpandHeights();
        }

        this.bindHandlers();

        this.timeout = null;
        this.rotated = 0;

        this.rotations[0].setFront();
        this.startRotation();

        Banner.adjustHeight();
    }

    bindHandlers() {
        let _self = this;

        $window.on('resize', function() {
            let height = null;

            if($(this).width() >= 850) {
                height = _self.getBiggestValue(_self.getRotationRowHeights());
            }else {
                height = _self.getBiggestValue(_self.getRotationHeights());
            }

            _self.height = height;
        });

        this.$rotator.on('mouseenter', function() {
            _self.stopRotation();
        });

        this.$rotator.on('mouseleave', function() {
            _self.startRotation();
        });
    }

    getRotations() {
        let _self = this,
            rotations = [];

        this.$rotator.find(Selectors.rotation).each(function() {
            rotations.push(new Rotation($(this)));
        });

        return rotations;
    }

    getBiggestValue(values) {
        return Math.max(...values);
    }

    getRotationRowHeights() {
        let heights = [];

        for(let i = 0; i < this.rotations.length; i++) {
            heights.push(this.rotations[i].getRowHeight(true));
        }

        return heights;
    }

    getRotationHeights() {
        let heights = [];

        for(let i = 0; i < this.rotations.length; i++) {
            heights.push(this.rotations[i].getRotationHeight());
        }

        return heights;
    }

    set height(height) {
        this.$rotator.css('height', height);
    }

    startRotation() {
        let _self = this;

        this.isRotating = true;

        if($window.width() < 850) {
            this.contractRotationContents();
        }

        this.timeout = setTimeout(function() {
            if(_self.rotated == 0) {
                _self.rotations[0].rotateBackwards();
                _self.rotations[1].rotateForwards();
                _self.rotated = 1;
            }else {
                _self.rotations[0].resetRotation();
                _self.rotations[1].resetRotation();
                _self.rotated = 0;
            }

            _self.startRotation();
        }, 6000);
    }

    stopRotation() {
        clearTimeout(this.timeout);
        this.timeout = null;
    }

    setRotationExpandHeights() {
        for(let i = 0; i < this.rotations.length; i++) {
            this.rotations[i].setExpandHeight(this.rotations[i].getRowHeight() + this.rotations[i].getResponsiveTitleHeight() + 2 * this.rotations[i].padding[0]);
        }
    }

    contractRotationContents() {
        for(let i = 0; i < this.rotations.length; i++) {
            this.rotations[i].contractContent();
        }
    }
}